import React from "react";

import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HappySchoolLayoutMain from "./pages/HappySchoolLayoutMain";
import Home from "./pages/Home";
import Blogs from "./pages/Blogs";

import Policy from "./pages/Policy";
import ChildSafetyStandards from "./pages/ChildSafetyStandards";
import DeleteAccount from "./pages/DeleteAccount";
import Contact from "./pages/Contact";
import NoPage from "./pages/NoPage";
import Java from "./pages/Java";
import Html from "./pages/Html";
import Css from "./pages/Css";
import JavaScriptPage from "./pages/JavaScript";
import Python from "./pages/Python";
import CSharp  from "./pages/CSharp";
import NodeJS from "./pages/NodeJS";
import AWSLambdaServerless from "./pages/AWSLambdaServerless";
import MicrosoftAzureFunctions from "./pages/MicrosoftAzureFunctions";
import GoogleCloudFunctions from "./pages/GoogleCloudFunctions";
import OnSuGame from "./pages/OnSuGame";
import Quiz3Home from "./pages/quiz3_static/Quiz3Home";
import Quiz3TakeQuiz from "./pages/quiz3_static/Quiz3TakeQuiz";
import Quiz3QuizPlayer from "./pages/quiz3_static/Quiz3QuizPlayer";
import Quiz3History from "./pages/quiz3_static/Quiz3History";
import Quiz3Author from "./pages/quiz3_static/Quiz3Author";
import Quiz3PrintSheet from "./pages/quiz3_static/Quiz3PrintSheet";
import Quiz3PrintAnswerKey from "./pages/quiz3_static/Quiz3PrintAnswerKey";
import Quiz3ScanSheet from "./pages/quiz3_static/Quiz3ScanSheet";
import Quiz3ScanBatch from "./pages/quiz3_static/Quiz3ScanBatch";
import HappySchoolHome from "./pages/happyschool_static/HappySchoolHome";
import HappySchoolSchools from "./pages/happyschool_static/HappySchoolSchools";
import HappySchoolTeachers from "./pages/happyschool_static/HappySchoolTeachers";
import HappySchoolStaffAll from "./pages/happyschool_static/HappySchoolStaffAll";
import HappySchoolTeacherBusy from "./pages/happyschool_static/HappySchoolTeacherBusy";
import HappySchoolSubjects from "./pages/happyschool_static/HappySchoolSubjects";
import HappySchoolClasses from "./pages/happyschool_static/HappySchoolClasses";
import HappySchoolClassList from "./pages/happyschool_static/HappySchoolClassList";
import HappySchoolCombinations from "./pages/happyschool_static/HappySchoolCombinations";
import HappySchoolCombinationTeachers from "./pages/happyschool_static/HappySchoolCombinationTeachers";
import HappySchoolHomeroomTeachers from "./pages/happyschool_static/HappySchoolHomeroomTeachers";
import HappySchoolStudents from "./pages/happyschool_static/HappySchoolStudents";
import HappySchoolDataTable from "./pages/happyschool_static/HappySchoolDataTable";
import HappySchoolStudentLists from "./pages/happyschool_static/HappySchoolStudentLists";
import HappySchoolYearTree from "./pages/happyschool_static/HappySchoolYearTree";
import HappySchoolVanThu from "./pages/happyschool_static/HappySchoolVanThu";
import HappySchoolTuition from "./pages/happyschool_static/HappySchoolTuition";
import HappySchoolPayroll from "./pages/happyschool_static/HappySchoolPayroll";
import HappySchoolMyPayroll from "./pages/happyschool_static/HappySchoolMyPayroll";
import HappySchoolTeachingHub from "./pages/happyschool_static/HappySchoolTeachingHub";
import HappySchoolMyBusyPage from "./pages/happyschool_static/HappySchoolMyBusyPage";
import HappySchoolJoinRequests from "./pages/happyschool_static/HappySchoolJoinRequests";
import HappySchoolUserAccounts from "./pages/happyschool_static/HappySchoolUserAccounts";
import HappySchoolMyProfile from "./pages/happyschool_static/HappySchoolMyProfile";
import HappySchoolDashboard from "./pages/happyschool_static/HappySchoolDashboard";
import HappySchoolScheduleHub from "./pages/happyschool_static/HappySchoolScheduleHub";
import HappySchoolTkbList from "./pages/happyschool_static/HappySchoolTkbList";
import HappySchoolChamCongThang from "./pages/happyschool_static/HappySchoolChamCongThang";
import HappySchoolLuongXe from "./pages/happyschool_static/HappySchoolLuongXe";
import HappySchoolChinhSachLuong from "./pages/happyschool_static/HappySchoolChinhSachLuong";
import HappySchoolThiKhaoSat from "./pages/happyschool_static/HappySchoolThiKhaoSat";
import HappySchoolDirectory from "./pages/happyschool_static/HappySchoolDirectory";
import HappySchoolViPhamGV from "./pages/happyschool_static/HappySchoolViPhamGV";
import HappySchoolChamCongDaoTao from "./pages/happyschool_static/HappySchoolChamCongDaoTao";
import HappySchoolVirtualClasses from "./pages/happyschool_static/HappySchoolVirtualClasses";
import HappySchoolFeatureRequests from "./pages/happyschool_static/HappySchoolFeatureRequests";
import HappySchoolPeriodRules from "./pages/happyschool_static/HappySchoolPeriodRules";
import HappySchoolPccmDraft from "./pages/happyschool_static/HappySchoolPccmDraft";
import HappySchoolPccmHistory from "./pages/happyschool_static/HappySchoolPccmHistory";
import HappySchoolTimetableView from "./pages/happyschool_static/HappySchoolTimetableView";
import HappySchoolSubstituteTeachers from "./pages/happyschool_static/HappySchoolSubstituteTeachers";
import Kubernetes from "./pages/Kubernetes";

import TaoForm from "./pages/saolait/TaoForm";
import Control from "./pages/saolait/Control";

import Login from "./Login";

export default function App() {
  return (
    <>
      <Routes>

        {/* Công khai, KHÔNG cần đăng nhập — Google Play cần truy cập được. */}
        <Route path="deleteaccount" element={<DeleteAccount />} />

        {/* Toàn bộ site giờ không còn phụ thuộc Firebase — layout chỉ render
            Outlet, mỗi trang tự lo đăng nhập/nội dung riêng nếu cần. */}
        <Route path="/" element={<HappySchoolLayoutMain />}>
          <Route index element={<Home />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="policy" element={<Policy />} />
          <Route path="child-safety-standards" element={<ChildSafetyStandards />} />
          <Route path="contact" element={<Contact />} />

          <Route path="java" element={<Java />} />
          <Route path="html" element={<Html />} />
          <Route path="saolait/taoform" element={<TaoForm />} />
          <Route path="saolait/control" element={<Control />} />
          <Route path="css" element={<Css />} />
          <Route path="javascript" element={<JavaScriptPage />} />
          <Route path="python" element={<Python />} />
          <Route path="csharp" element={<CSharp />} />
          <Route path="nodejs" element={<NodeJS />} />

          <Route path="login" element={<Login />} />

          <Route path="game" element={<OnSuGame />} />

          <Route path="awslambdaserverless" element={<AWSLambdaServerless />} />
          <Route path="microsoftazurefunctions" element={<MicrosoftAzureFunctions />} />
          <Route path="googlecloudfunctions" element={<GoogleCloudFunctions />} />
          <Route path="kubernetes" element={<Kubernetes />} />

          <Route path="quiz3" element={<Quiz3Home />} />
          <Route path="quiz3/take" element={<Quiz3TakeQuiz />} />
          <Route path="quiz3/play/:quizId" element={<Quiz3QuizPlayer />} />
          <Route path="quiz3/history" element={<Quiz3History />} />
          <Route path="quiz3/author" element={<Quiz3Author />} />
          <Route path="quiz3/print/:quizId" element={<Quiz3PrintSheet />} />
          <Route path="quiz3/answerkey/:quizId" element={<Quiz3PrintAnswerKey />} />
          <Route path="quiz3/scan/:quizId" element={<Quiz3ScanSheet />} />
          <Route path="quiz3/scan-batch" element={<Quiz3ScanBatch />} />
          <Route path="happyschool" element={<HappySchoolHome />} />
          <Route path="happyschool/schools" element={<HappySchoolSchools />} />
          <Route path="happyschool/staff" element={<HappySchoolStaffAll />} />
          <Route path="happyschool/teachers" element={<HappySchoolTeachers />} />
          <Route path="happyschool/teachers/busy" element={<HappySchoolTeacherBusy />} />
          <Route path="happyschool/subjects" element={<HappySchoolSubjects />} />
          <Route path="happyschool/classes" element={<HappySchoolClasses />} />
          <Route path="happyschool/class-list" element={<HappySchoolClassList />} />
          <Route path="happyschool/combinations" element={<HappySchoolCombinations />} />
          <Route path="happyschool/combinations/:group" element={<HappySchoolCombinations />} />
          <Route path="happyschool/combination-teachers/:group" element={<HappySchoolCombinationTeachers />} />
          <Route path="happyschool/homeroom-teachers" element={<HappySchoolHomeroomTeachers />} />
          <Route path="happyschool/period-rules" element={<HappySchoolPeriodRules />} />
          <Route path="happyschool/pccm-draft" element={<HappySchoolPccmDraft />} />
          <Route path="happyschool/pccm-history" element={<HappySchoolPccmHistory />} />
          <Route path="happyschool/students" element={<HappySchoolStudents />} />
          <Route path="happyschool/dashboard" element={<HappySchoolDashboard />} />
          <Route path="happyschool/generate" element={<HappySchoolScheduleHub />} />
          <Route path="happyschool/tkb" element={<HappySchoolTkbList />} />
          <Route path="happyschool/tkb/:weekId" element={<HappySchoolTkbList />} />
          <Route path="happyschool/substitute" element={<div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }}><h2 style={{ margin: "0 0 12px" }}>☎️ Giáo viên dạy thay</h2><HappySchoolSubstituteTeachers adminMode /></div>} />
          <Route path="happyschool/chamcong-thang" element={<HappySchoolChamCongThang />} />
          <Route path="happyschool/luong-xe" element={<HappySchoolLuongXe />} />
          <Route path="happyschool/chinh-sach-luong" element={<HappySchoolChinhSachLuong />} />
          <Route path="happyschool/thi-khao-sat" element={<HappySchoolThiKhaoSat />} />
          <Route path="happyschool/directory" element={<HappySchoolDirectory />} />
          <Route path="happyschool/vipham-gv" element={<HappySchoolViPhamGV />} />
          <Route path="happyschool/chamcong-dao-tao" element={<HappySchoolChamCongDaoTao />} />
          <Route path="happyschool/virtual-classes" element={<HappySchoolVirtualClasses />} />
          <Route path="happyschool/feature-requests" element={<HappySchoolFeatureRequests />} />
          <Route path="happyschool/timetable/:runId" element={<HappySchoolTimetableView />} />
          <Route path="happyschool/bus" element={<HappySchoolDataTable tableKey="bus" />} />
          <Route path="happyschool/meals" element={<HappySchoolDataTable tableKey="meals" />} />
          <Route path="happyschool/parent-companion" element={<HappySchoolDataTable tableKey="parent" />} />
          <Route path="happyschool/admission10" element={<HappySchoolDataTable tableKey="admission10" />} />
          <Route path="happyschool/recruitment" element={<HappySchoolDataTable tableKey="recruitment" />} />
          <Route path="happyschool/teacher-eval" element={<HappySchoolDataTable tableKey="teacherEval" />} />
          <Route path="happyschool/teaching" element={<HappySchoolTeachingHub />} />
          <Route path="happyschool/my-busy" element={<HappySchoolMyBusyPage />} />
          <Route path="happyschool/join-requests" element={<HappySchoolJoinRequests />} />
          <Route path="happyschool/user-accounts" element={<HappySchoolUserAccounts />} />
          <Route path="happyschool/my-profile" element={<HappySchoolMyProfile />} />
          <Route path="happyschool/student-lists" element={<HappySchoolStudentLists />} />
          <Route path="happyschool/hssv-k12" element={<HappySchoolYearTree title="HSSV Đã ra trường" icon="🧑‍🎓" yearsKey="k12years" keyPrefix="k12" subLists={["hssvToanKhoi12", "hssvTotNghiep", "bangDiemTN", "hssvUuTu", "hssvDoCDDH", "hssvDiLamNgay", "hssvTruotTN"]} />} />
          <Route path="happyschool/nhom-hoan-canh" element={<HappySchoolYearTree title="HSSV Thuộc diện hoàn cảnh, chính sách" icon="🤲" yearsKey="hoancanhyears" keyPrefix="hc" subLists={["hssvHoNgheo", "hssvNeoDon", "hssvHoTro"]} />} />
          <Route path="happyschool/van-thu" element={<HappySchoolVanThu />} />
          <Route path="happyschool/tuition" element={<HappySchoolTuition />} />
          <Route path="happyschool/payroll" element={<HappySchoolPayroll />} />
          <Route path="happyschool/my-payroll" element={<HappySchoolMyPayroll />} />
          <Route path="happyschool/list/:tableKey" element={<HappySchoolDataTable />} />

          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </>
  );
}
